import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const routes = [
    {
        path: "/",
        redirect: "/list",
    },
    {
        path: "/ru",
        redirect: "/list",
    },
    {
        path: "/en",
        redirect: "/list",
    },
    {
        path: "/auth",
        name: "Auth",
        component: () =>
            import(
                /* webpackChunkName: "auth" */ "../views/LoginRegistration.vue"
            ),
    },
    {
        path: "/list",
        name: "List",
        component: () =>
            import(/* webpackChunkName: "list" */ "../views/SurveysList.vue"),
    },
    {
        path: "/create",
        name: "CreateSurvey",
        component: () =>
            import(
                /* webpackChunkName: "create" */ "../views/CreateEditSurvey.vue"
            ),
    },
    {
        path: "/edit/:id",
        name: "EditSurvey",
        component: () =>
            import(
                /* webpackChunkName: "edit" */ "../views/CreateEditSurvey.vue"
            ),
    },
    {
        path: "/details/:id",
        name: "Details",
        component: () =>
            import(
                /* webpackChunkName: "details" */ "../views/SurveyDetails.vue"
            ),
    },
    {
        path: "/profile/",
        name: "Profile",
        component: () =>
            import(
                /* webpackChunkName: "profile" */ "../views/UserProfile.vue"
            ),
    },
    {
        path: "/profile/change_password_key/:token",
        name: "ProfileToken",
        component: () =>
            import(
                /* webpackChunkName: "profile" */ "../views/UserProfile.vue"
            ),
    },
    {
        path: "/profile/activate/:token/:change_password_key?",
        name: "ProfileActivate",
        beforeEnter: (to, from, next) => {
            store.dispatch("Auth/tokenValidate", to.params.token, to.params.change_password_key).then(() => {
                store.dispatch("Auth/loginToken", to.params.token).then(() => {
                    if (to.params.change_password_key) {
                        next({
                            name: "ProfileToken",
                            params: {
                                token: to.params.change_password_key,
                            },
                        })
                    } else {
                        next({
                            name: "List",
                        })
                    }
                })
            })
        }
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
